import { ApiDealerXClient } from "@dealer-group/dealer-api-clients";

export function downloadEmailAttachment(messageUuid, fileUuid) {
    return ApiDealerXClient.get(`mailbox/message/${messageUuid}/attachment/${fileUuid}`, '', {}, {responseType: 'blob'});
}

export function downloadEmailAttachmentWhenEdit(mailboxUuid, fileUuid, fileName) {
    return ApiDealerXClient.get(`mailbox/${mailboxUuid}/preview_attachment/${fileUuid}/${fileName}`, '', {}, {responseType: 'blob'});
}

// return ApiDealerXClient.get(`mailbox/message/${messageUuid}/preview_attachment/${fileUuid}/${fileName}`, '', {}, {responseType: 'blob'});